/**
 * Site configuration utilities
 * Provides consistent access to site URLs and other configuration
 */

/**
 * Get the base site URL
 * In production, this will use the VITE_SITE_URL environment variable
 * In development, it will use the current window location
 */
export const getSiteUrl = (): string => {
  const envSiteUrl = import.meta.env.VITE_SITE_URL;
  
  // Use the environment variable if available
  if (envSiteUrl) {
    return envSiteUrl;
  }
  
  // Fallback to window.location.origin in browser environments
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  
  // Return empty string if neither is available (should not happen in practice)
  return '';
};

/**
 * Get a full URL for a specific path
 * @param path - The path to append to the site URL
 */
export const getFullUrl = (path: string): string => {
  const baseUrl = getSiteUrl();
  
  // Ensure path starts with a slash
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  
  return `${baseUrl}${normalizedPath}`;
};

/**
 * Configuration for authentication redirects
 */
export const authConfig = {
  /**
   * URL to redirect to after password reset
   */
  passwordResetRedirectUrl: getFullUrl('/reset-password/update'),
  
  /**
   * URL to redirect to after email verification
   */
  emailVerificationRedirectUrl: getFullUrl('/login'),
  
  /**
   * URL to redirect to after sign in
   */
  signInRedirectUrl: getFullUrl('/')
}; 